import {
    IMappingProfile,
    IQueryParams,
    IQueryParamsSymbol,
    PFWmsEntities,
} from '@pf/shared-common';
import { createMap, Mapper } from '@automapper/core';
import {
    entitySymbols,
    withDefaultEntityMetadata,
    withDefaultSearchParamsMappingConfiguration,
    withDefaultSearchParamsMetadata,
    withMetadata,
} from '@pf/shared-utility';
import {
    PickCreate,
    PickDto,
    PickRead,
    PickSearchParams,
} from '../../entities/pick.dto';
import {
    DefaultLocationFragmentMetadataMap,
    DefaultPickListFragmentMetadataMap,
    DefaultPickLocationFragmentMetadataMap,
    ResourceAuthSymbol,
} from '@pf/shared/util-platform';
import { ItemMetadataMap } from '@pf/platform-item-catalog/domain';

const symbols = entitySymbols(PFWmsEntities.Pick);

withDefaultEntityMetadata<PickDto>(symbols.dto, {
    name: String,
    status: String,
    location: DefaultLocationFragmentMetadataMap.symbols.dto,
    pickList: DefaultPickListFragmentMetadataMap.symbols.dto,
    salesOrderLines: [String],
    pickLocations: [DefaultPickLocationFragmentMetadataMap.symbols.dto],
    quantityNeeded: Number,
    pickedQuantity: Number,
    needsReview: Boolean,
    item: ItemMetadataMap.symbols.entity,
    itemId: String,
    quantityToPick: Number,
    resourceAuth: ResourceAuthSymbol,
});

withDefaultEntityMetadata<PickRead>(symbols.entity, {
    item: ItemMetadataMap.symbols.entity,
    itemId: String,
    quantityToPick: Number,
    status: String,
    pickList: DefaultPickListFragmentMetadataMap.symbols.entity,
    salesOrderLines: [String],
    pickLocations: [DefaultPickLocationFragmentMetadataMap.symbols.entity],
    quantityNeeded: Number,
    pickedQuantity: Number,
    needsReview: Boolean,
    resourceAuth: ResourceAuthSymbol,
});

withMetadata<PickCreate>(symbols.createBody, {
    itemId: String,
    quantityToPick: Number,
    status: String,
    pickListId: String,
    resourceAuth: ResourceAuthSymbol,
});

withDefaultSearchParamsMetadata<PickSearchParams>(symbols.searchParams, {});

export const PickMetadataMap: IMappingProfile = {
    symbols,
    profile: (mapper: Mapper) => {
        createMap<PickRead, PickDto>(mapper, symbols.entity, symbols.dto);
        createMap<PickDto, PickRead>(mapper, symbols.dto, symbols.entity);
        createMap<PickDto, PickCreate>(mapper, symbols.dto, symbols.createBody);
        createMap<IQueryParams<PickDto>, PickSearchParams>(
            mapper,
            IQueryParamsSymbol,
            symbols.searchParams,
            ...withDefaultSearchParamsMappingConfiguration()
        );

        DefaultLocationFragmentMetadataMap.profile(mapper);
        DefaultPickListFragmentMetadataMap.profile(mapper);
        DefaultPickLocationFragmentMetadataMap.profile(mapper);
    },
};
